import React from "react";
import "./Section2.css";
import Section2Image from "../../../../../assets/images/itinsrsec2-img1.png";
import ProfDots from "../../../../../assets/images/aboutus-dots.png";
const Section2 = () => {
  return (
    <div className="itinsrsec2_section">
      <img src={ProfDots} alt="" className="itinsrsec2__section_dots" />
      <div className="itinsrsec2__section_left">
        <div className="itinsrsec2__secleft_heading">When should I apply?</div>
        <div className="itinsrsec2__secleft_description">
          <p>
            You can apply for an ITIN any time during the year when you have a
            filing or reporting requirement. At a minimum, you should complete
            Form W-7 when you are ready to file your federal income tax return
            by the return’s prescribed due date. If the tax return you attach to
            Form W-7 is filed after the return’s due date, you may owe interest
            and/or penalties.
          </p>
        </div>
      </div>
      <div className="itinsrsec2__section_right">
        <img src={Section2Image} alt="" className="itinsrsec2__section_img" />
      </div>
    </div>
  );
};

export default Section2;
